module.exports = __webpack_public_path__ + "img/64200.65acbdbc.jpg";